/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from "react";
import queryString from "query-string";

import { WithLocalize } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";

import "./style.scss";
import Helmet from 'react-helmet';
import favicon from "./image/simboloplay.png";
import LoginForm from "./LoginForm";
import logo from "./image/logoplay.png";

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (
      !this.parameters.client_id ||
      !this.parameters.redirect_uri ||
      !this.parameters.response_type
    ) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = "multiplic-body";
    document.title = "Multiplic Play";
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="multiplic-container">
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <div className="multiplic-container-logo">
          <img src={logo} alt="multiplicrtes" className="multiplic-logo" />
        </div>
        {this._validateParams() ? (
          <LoginForm api={this.api} location={this.props.location} />
        ) : (
          <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate("RequestLoginErrorMessage")}
          />
        )}
      </div>
    );
  }
}

export default WithLocalize(Login);
